 <!--page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-top-history cf">
      	<div class="container">
      	   <div class="ashton-hero-top-history-detail cf">
      	   	   <div class="ashton-hero-top-history-detail-inner ">
	      	   	   <div class="ashton-hero-top-history-image">
	      	   	   	   <img src="assets/images/Bitmap-icon.png">
	      	   	   </div>
	      	   	   <h2>history</h2>
	      	   	</div>
      	   </div> 	
      	</div>
      	<div class="ashton-hero-top-clubsponsorship-overlay"></div>
      </div>
      <div class="ashton-hero-center-history-section cf">
      	<div class="container">
      	  	<div class="ashton-hero-center-history-detail">
      	  		<div class="ashton-hero-center-history-box" *ngFor="let history of historyList?.data">
                <a [routerLink]="['/history-single', history?.slug]">
        	  			<div class="ashton-hero-center-history-box-image" [ngStyle]="{'background-image':'url(' + history?.image + ')'}">
        	  				<div class="ashton-hero-center-history-box-content">
  	      	  				<h2>{{history?.title}}<br> 20th century boys</h2>
  	      	  			</div>
        	  			</div>
                </a>
      	  		</div>
      	  		<!-- <div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div> -->
      	  	</div>
      	  	<div class="our-charity-detail cf">
              <div class="our-charity-left">
                <h3>OUR CHARITY</h3>
                <p>ASHTON UNITED IN COMMUNITY</p>
                <div class="our-charity-left-btn">
                  <a href="https://www.auitc.co.uk/" target="_blank"class="seemore-white">Know More</a>
                </div>
              </div>
              <div class="our-charity-right">
                <img src="assets/images/Bitmap-icon.png" alt="Bitmap-icon">
              </div>
           </div>
           <div class="show-your-support-detail cf">
             <div class="show-your-support-left">
               <h3>SHOW YOUR SUPPORT</h3>
               <p>& JOIN THE ROBINS TODAY!</p>
             </div>
             <div class="show-your-support-right">
                <div class="show-your-support-right-content">
                  <div class="show-your-support-right-content-titel">
                    Subscribe for email updates
                  </div>
                  <div class="show-your-support-right-content-inputbox">
                    <input type="email" name="" placeholder="Add Email Address">
                  </div>
                 
                </div>
                <div class="show-your-support-right-btn">
                   <a href="javascript:void(0);">SUBMIT</a>
                </div>
             </div>
           </div>
      	</div>
      </div>
    </section><!-- page ends -->
    
